import React from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';

import SubHeading from '@components/sub-heading';
import PlatformCard from '@components/platforms/platform-card';
import ItemsTray from '@components/items-tray';

import { BlogHomepageCardPlatformType } from '../../types';
import SeeAllLink from '@components/see-all-link';
import { BrowserType } from '@constants/common';
import { PlatformType } from '@invideoio/web-shared/constants/common';

interface PlatformListProps {
  platformList: BlogHomepageCardPlatformType[];
  SubHeadingTitle: string;
  viewAllURL?: string;
  platform: PlatformType;
  browser: BrowserType;
}

const Platforms = (props: PlatformListProps) => {
  const { platformList, SubHeadingTitle, viewAllURL, platform, browser } =
    props;
  return (
    <section
      className={ivclass(
        'iv-pt-[91px] lg:iv-pt-[91px] md:iv-pt-[52px] sm:iv-pt-[44px]',
        'iv-pb-100 md:iv-pb-50 sm:iv-pb-30',
        'lg:iv-pl-[43px] md:iv-pl-[25px] sm:iv-pl-[21px]',
      )}
    >
      <div className={ivclass('iv-grid iv-grid-cols-12 iv-col-span-12 ')}>
        <div className={ivclass('iv-col-span-12')}>
          <SubHeading title={SubHeadingTitle} viewAllURL={viewAllURL} />
        </div>
      </div>
      <div className={ivclass('sm:iv-mt-5')}>
        {Array.isArray(platformList) && (
          <ItemsTray
            platform={platform}
            sliderWrapperCls={ivclass(
              'lg:iv-mr-20',
              'md:iv-mr-[12px]',
              'sm:iv-mr-10',
            )}
          >
            {platformList?.map(blogPlatform => (
              <div
                key={blogPlatform.id}
                className={ivclass(
                  'iv-relative',
                  'iv-mr-40 md:iv-mr-25 sm:iv-mr-20',
                )}
              >
                <PlatformCard
                  browser={browser}
                  platform={platform}
                  {...blogPlatform}
                />
              </div>
            ))}
          </ItemsTray>
        )}
      </div>
      <div
        className={ivclass(
          'xl:iv-hidden lg:iv-hidden md:iv-hidden ',
          'iv-flex iv-justify-center',
          'sm:iv-mt-30',
        )}
      >
        {viewAllURL && <SeeAllLink viewAllURL={viewAllURL} />}
      </div>
    </section>
  );
};

export default Platforms;
